import styled from "styled-components";

export const Container = styled.tr`
  display: flex;

  width: 100%;
  min-height: 3.5rem;

  font-size: 0.9rem;

  border-bottom: #dfe0eb 1px solid;
  border-radius: 0rem;

  white-space: nowrap;

  color: black;

  text-decoration: none;

  align-items: center;
  justify-content: center;

  a {
    transition: all 0.1s;

    :last-child {
      border-bottom: none;
    }
  }

  a:hover {
    cursor: pointer;

    background-color: #3751ff;

    color: white;
  }

  td {
    display: flex;

    position: relative;

    width: 12.5%;
    height: 2rem;

    align-items: center;
    justify-content: center;

    font-size: 1rem;

    margin-left: 0.5rem;

    :last-child {
      width: 10%;
    }
  }

  #prop-name {
    font-weight: 700;

    justify-content: flex-start;

    text-transform: capitalize;
  }

  #process-text {
    color: #8a8a8a;
    font-weight: 600;
    text-transform: uppercase;
  }

  #icon {
    position: absolute;
    right: 1rem;
  }

  #options {
    overflow: visible;
  }

  .name-text {
    font-weight: 700;

    text-transform: capitalize;
  }

  #more_options {
    display: flex;
    flex-direction: column;

    position: relative;

    align-items: center;
    justify-self: center;

    cursor: pointer;

    width: 1.5rem;

    .dropdown-content.hidden {
      display: none;
    }

    .dropdown-content.show {
      display: flex;
      flex-direction: column;

      position: absolute;

      width: 5rem;
      height: 5rem;

      justify-content: space-between;

      top: 1.5rem;

      div {
        display: flex;
        flex-direction: column;

        width: 100%;
        height: 100%;
      }

      button {
        width: 100%;
        height: 3rem;

        border-radius: 0.4rem;

        margin-bottom: 0.5rem;

        cursor: pointer;

        font-size: 1rem;

        background: white;

        transition: 0.2s;
      }

      #delete {
        background-color: #d11919;

        border: none;

        color: white;
      }

      #cancel {
        border: 1px solid #3751ff;

        color: #3751ff;

        :hover {
          background-color: #3751ff;

          color: white;
        }
      }
    }
  }
`;
